let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("arhgZ"), load("kvw4Z")]).then(() => parcelRequire('3IEiO'));